// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import { MainPanel, RootPath } from "types";

export interface IStateRouter {
  rootPath?: RootPath;
  panel?: MainPanel;
  widget?: number;
  charger?: number; // for ocpp charger pages: ocpp charger id; for energy management chargers: charger index
  connector?: number; // ocpp connector id
  transaction?: number; // t_charging_sessions.id
  rfid?: number; // t_rfid.id
  report?: number;
  user?: number;
}

/* initial state */
export const INITIAL_STATE: IStateRouter = {};
